// extracted by mini-css-extract-plugin
export default {"productDescription":"aaa-z","featuredDescription":"baa-z","description":"caa-z","more":"daa-z","descriptionSku":"eaa-z"};